var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "GetStartedLayout",
    {
      staticClass: "white",
      attrs: {
        errors: _vm.errors,
        title: "Amazing!",
        subtitle: `Receipt sent to ${_vm.client.email}`,
        guest: _vm.client,
        needHelp: false,
      },
    },
    [
      _c(
        "v-container",
        { staticStyle: { "min-height": "50vh" } },
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  staticClass: "mx-auto",
                  attrs: { cols: "12", sm: "8", md: "6" },
                },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "mx-auto soli-round",
                      staticStyle: { border: "none", "max-width": "500px" },
                    },
                    [
                      _c("v-img", {
                        attrs: {
                          src: "/four-guitars.webp",
                          height: "200px",
                          position: "top",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "v-container",
                        { staticClass: "px-4 text-align-center" },
                        [
                          _c("v-card-title", { staticClass: "soli-grey" }, [
                            _vm._v(
                              "\n                            Students who start lessons with a friend are\n                            more motivated and make more progress\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-card-subtitle",
                            { staticClass: "subtitle-1 soli-grey pt-2" },
                            [
                              _vm._v(
                                "\n                            Who do you know who might want to take lessons\n                            with you?\n                        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-card-actions",
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "accent",
                                    large: "",
                                    rounded: "",
                                    outlined: "",
                                    block: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.share()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                Share"
                                  ),
                                  _c("v-icon", [_vm._v("share")]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "my-6 flex flex-col" },
                    [
                      _c(
                        "v-card-subtitle",
                        { staticClass: "subtitle-1 pb-0 text-align-center" },
                        [_vm._v("Happy music-making!")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card-subtitle",
                        { staticClass: "pt-0 subtitle-1 text-align-center" },
                        [_vm._v("Team Musicologie")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }